// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file environment_info/natgw.proto (package environment_info, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message environment_info.NatGwRequest
 */
export type NatGwRequest = {
/**
 * @generated from field: environment_info.UserContext user_context = 1;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message environment_info.NatGwResponse
 */
export type NatGwResponse = {
/**
 * @generated from field: repeated string public_ips = 1;
 */
publicIps?: string[];
}
;
/**
 * @generated from message environment_info.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from message environment_info.EnvIdRequest
 */
export type EnvIdRequest = {
}
;
/**
 * @generated from message environment_info.EnvIdResponse
 */
export type EnvIdResponse = {
/**
 * @generated from field: string env_id = 1;
 */
envId?: string;
}
;
/**
 * ResourceBlockConsent represents the environment's preference for whether resources
 * should be blocked once cumulative AI unit usage reaches 100% of the contract threshold.
 *
 * @generated from message environment_info.GetResourceBlockConsentRequest
 */
export type GetResourceBlockConsentRequest = {
}
;
/**
 * @generated from message environment_info.GetResourceBlockConsentResponse
 */
export type GetResourceBlockConsentResponse = {
/**
 * @generated from field: bool block_at_hundred_percent = 1;
 */
blockAtHundredPercent?: boolean;
/**
 * user_email of the last person who set this preference
 *
 * @generated from field: string consented_by_email = 2;
 */
consentedByEmail?: string;
/**
 * RFC3339 timestamp of the last change
 *
 * @generated from field: string consented_at = 3;
 */
consentedAt?: string;
}
;
/**
 * @generated from message environment_info.SetResourceBlockConsentRequest
 */
export type SetResourceBlockConsentRequest = {
/**
 * @generated from field: bool block_at_hundred_percent = 1;
 */
blockAtHundredPercent?: boolean;
/**
 * @generated from field: environment_info.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message environment_info.SetResourceBlockConsentResponse
 */
export type SetResourceBlockConsentResponse = {
/**
 * @generated from field: bool success = 1;
 */
success?: boolean;
}
;
/**
 * @generated from rpc environment_info.NatGwService.GetNatGwIps
 */
export const NatGwService_GetNatGwIps = new RPC<NatGwRequest,NatGwResponse>("POST", "/getNatGWIP");
/**
 * @generated from rpc environment_info.NatGwService.GetEnvId
 */
export const NatGwService_GetEnvId = new RPC<EnvIdRequest,EnvIdResponse>("GET", "/getEnvId");
/**
 * @generated from rpc environment_info.NatGwService.GetResourceBlockConsent
 */
export const NatGwService_GetResourceBlockConsent = new RPC<GetResourceBlockConsentRequest,GetResourceBlockConsentResponse>("GET", "/getResourceBlockConsent");
/**
 * @generated from rpc environment_info.NatGwService.SetResourceBlockConsent
 */
export const NatGwService_SetResourceBlockConsent = new RPC<SetResourceBlockConsentRequest,SetResourceBlockConsentResponse>("POST", "/setResourceBlockConsent");
